import { render, staticRenderFns } from "./PermissionFormItem.vue?vue&type=template&id=c7c88826&scoped=true"
import script from "./PermissionFormItem.vue?vue&type=script&lang=js"
export * from "./PermissionFormItem.vue?vue&type=script&lang=js"
import style0 from "./PermissionFormItem.css?vue&type=style&index=0&id=c7c88826&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7c88826",
  null
  
)

export default component.exports